import GameIds from '../../hub/data/GameIds';

export const CONTENT_VERSION = '0.0.5';
export const GAME_ID = GameIds.UNMASK_THAT;

export const ITEMS_PER_LEVEL = 6;
export const NUM_LEVELS = 8;
export const STANDARD_ITEM_SETS_PER_LEVEL = 2;
export const CORRECT_ITEMS_TO_MASTER = 5;
export const START_ANIMATION_DURATION = 6900;
export const HIGHEST_K2_LEVEL = 5;

export const GRADE_LEVELS = {
  gK_TO_2: 'Kto2',
  g3_TO_5: '3to5',
};

// Enum for consistency in windowType
export const ACTIVITY_WINDOW_TYPE = {
  CLOSEDSCROLL: 'closedscroll',
  TRANSITION: 'transition',
  PROGRESS: 'progress',
  LEVEL: 'level',
  LOADING: 'loading',
};

// Enum for which portion of a level should show
export const LEVEL_STAGE = {
  ONBOARDING: 'onboarding',
  STANDARD: 'standard',
  PRACTICE: 'practice',
  MYSTERY: 'mystery',
};

// Enum for what should show at the bottom of the screen:
// nothing (NONE), DoneButton (DONE), checkmark (CORRECT),
// x (INCORRECT), etc.
export const FEEDBACK_DISPLAY = {
  NONE: 'none',
  DONE: 'done',
  CORRECT: 'correct',
  CORRECT_SLIDE: 'correctSlide',
  INCORRECT: 'incorrect',
  TRANSITION: 'transition',
};

// What should be happening with the Droppable
// at any point: showing highlighted (ACTIVE), showing
// gray (INACTIVE), or not showing at all (PLAIN)
export const DROPPABLE_TYPE = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PLAIN: 'plain',
};

// Styling and functionality depnds on this enum in the Word
// component
export const WORD_TYPE = {
  ANAPHORA: 'anaphora',
  SELECTED: 'selected',
  INTERACTABLE: 'interactable',
  PLAIN: 'plain',
  GLOW: 'glow',
};

// Styling Mask components
export const MASK_COLOR = {
  COLOR: 'color',
  DARK: 'dark',
  WHITE: 'white',
  GREY: 'grey',
  PRACTICE_COLOR: 'practiceColor',
  WRONG_COLOR: 'wrongColor',
};
